export default class AnalysisRecord {
  constructor() {
    this.analyses = {};
    this.cachedData = {};
    this.latestAnalysis = null;
    this.latestElevation = null;
  }

  update(newAnalysis, newElevation, data) {
    let analysis = this.analyses[newAnalysis];
    if (!analysis) {
      analysis = [];
      this.analyses[newAnalysis] = analysis;
    }
    if (analysis.indexOf(newElevation) === -1) {
      analysis.push(newElevation);
      analysis.sort(function(a, b) {
        return a > b;
      });
      this.latestElevation = newElevation;
      this.latestAnalysis = newAnalysis;
    }
    if (typeof data !== 'undefined') {
      var cachedData = this.cachedData[newAnalysis];
      if (!cachedData) {
        cachedData = {};
        this.cachedData[newAnalysis] = cachedData;
      }
      if (!cachedData[newElevation]) {
        cachedData[newElevation] = data;
      }
    }
  }
  getCachedData(analysis, elevation) {
    return analysis in this.cachedData
      ? this.cachedData[analysis][elevation]
      : null;
  }

  analyzedOrNot(analysis, allElevations) {
    var notAnalyzed = [];
    var analyzed = [];

    for (let i = 0; i < allElevations.length; i++) {
      let elevation = allElevations[i];
      if (
        analysis in this.analyses &&
        this.analyses[analysis].indexOf(elevation) > -1
      ) {
        analyzed.push(elevation);
      } else {
        notAnalyzed.push(elevation);
      }
    }

    return { analyzed, notAnalyzed };
  }
}
